import React, { useEffect, useState } from 'react';
import { useStore } from 'common/store';
import { FormDialog } from 'components';
import { CapTableForm } from 'components/Forms';
import { CapTableDefaultFormState, CapTableFormState } from 'components/Forms/CapTableForm/CapTableForm.props';
import { useUpdateCaptableInfo } from 'services/hooks/captable';
import { CapTableDialogProps } from './CapTableDialog.props';

const CapTableDialog = ({ open, onClose, onSave }: CapTableDialogProps) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const [, updateCapTableData] = useUpdateCaptableInfo({ captableId: null, captableInfo: null });
  const [{ captableInfo }] = useStore();

  const [formState, setFormState] = useState<CapTableFormState>({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  });

  useEffect(() => {
    if (captableInfo) {
      setFormState(prevFormState => ({
        ...prevFormState,
        values: { name: captableInfo.name },
      }));
    }
  }, [captableInfo]);

  const saveData = async () => {
    // sheet_attribute_mapping is an integer ID in the store (read shape) but the
    // write serializer expects a dict or null. Exclude it so the backend leaves
    // the existing mapping untouched.
    const { sheet_attribute_mapping: _omit, ...captableInfoWithoutMapping } = captableInfo;
    const temporalCaptableInfo = { ...captableInfoWithoutMapping, name: formState.values.name };
    await updateCapTableData(captableInfo.id, temporalCaptableInfo);
    onSave();
  };

  return (
    <FormDialog
      open={open}
      title={captableInfo.name}
      onSave={saveData}
      onClose={onClose}
      isValid={formState.isValid}
      editMode>
      <CapTableForm
        defaultFormState={formState as CapTableDefaultFormState}
        onFormChange={prevFormState => setFormState(prevFormState)}
      />
    </FormDialog>
  );
};

export default CapTableDialog;
